import React, { Dispatch, FC, SetStateAction, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import CallBackFormModal from '@/components/HomePage/CallBackForm/modal';
import ButtonDefault, {
  ButtonVariants,
} from '@/components/shared/basic/button';

interface Props {
  setLoading: Dispatch<SetStateAction<boolean>>;
  loading: boolean;
  onSuccess: () => void;
  className?: string;
}
const RequestCallBack: FC<Props> = ({
  loading,
  setLoading,
  onSuccess,
  className,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <div
      className={twMerge(
        `justify-center gap-4 max-w-[800px] w-full bg-orangeZl-600 md:p-8 p-5 rounded-[4px] flex items-center md:justify-between self-center flex-wrap`,
        className,
      )}
    >
      <div className='flex flex-col'>
        <p className='md:text-2xl text-lg text-white'>
          Ready to start your Journey?
        </p>
        <p className='md:text-base text-xs text-white'>
          We help writers publish their book.
        </p>
      </div>
      <ButtonDefault
        onClick={showModal}
        variant={ButtonVariants.WHITE}
        size={0}
        className='md:px-8 px-4 md:py-4 py-2.5 md:text-base text-sm '
      >
        Request A Call Back
      </ButtonDefault>
      <CallBackFormModal
        onSuccess={onSuccess}
        open={isModalOpen}
        onCancel={handleCancel}
        onOk={handleOk}
        loading={loading}
        setLoading={setLoading}
      />
    </div>
  );
};

export default RequestCallBack;
